export function handleStakeHelper(first, second, setctx) {
  setctx(ctx => {
    return { ...ctx, stakes: { firstStake: first, secondStake: second } }
  })
}
export function handleAutoInputsHelper(inputNumber, key, value, setctx) {
  setctx(ctx => {
    return {
      ...ctx,
      auto: {
        ...ctx.auto,
        [inputNumber]: { ...ctx.auto[inputNumber], [key]: value },
      },
    }
  })
}
//TODO ეს ჩამატებულია სეთინგების შენახვისთვის მაგრამ დროებით არ ვაკეთებთ
// export function handleAutoInputsSocketHelper(inputNumber, numberOfBets, cashOut, setctx){
//   setctx(ctx => {
//     return {
//       ...ctx,
//       auto: {  ...ctx.auto, [inputNumber]: { ...ctx.auto[inputNumber], numberOfBets, cashOut } },
//     }
//   })
// }

export function handleSettingsHelper(show, setctx) {
  setctx(ctx => {
    return { ...ctx, settings: { ...ctx.settings, showSettings: show } }
  })
}
export function handleSettingsSubpageHelper(page, setctx) {
  setctx(ctx => {
    return { ...ctx, settings: { ...ctx.settings, settingsSubpage: page } }
  })
}

export function handleJackpotPopupHelper(popup, setctx) {
  setctx(ctx => {
    return { ...ctx, jackpotPopup: popup }
  })
}

export function handleShowAutoHelper(first, second, setctx) {
  setctx(ctx => {
    return {
      ...ctx,
      auto: {
        first: { ...ctx.auto.first, showAuto: first },
        second: { ...ctx.auto.second, showAuto: second },
      },
    }
  })
}

export function setFooterFirstStateHelper(state, setctx) {
  setctx(ctx => {
    return { ...ctx, footerStates: { ...ctx.footerStates, firstState: state } }
  })
}

export function setFooterSecondStateHelper(state, setctx) {
  setctx(ctx => {
    return { ...ctx, footerStates: { ...ctx.footerStates, secondState: state } }
  })
}
export function handleIsplayingHelper(setctx) {
  setctx(ctx => {
    const firstState = ctx.footerStates.firstState
    const secondState = ctx.footerStates.secondState
    return {
      ...ctx,
      firstIsPlaying: firstState !== "bet" && firstState !== "start auto",
      secondIsPlaying: secondState !== "bet" && secondState !== "start auto",
    }
  })
}
export function handleFuncsInContext(
  setctx,
  handleStake,
  handleShowAuto,
  handleSettings,
  handleAutoInputs,
  setFooterFirstState,
  setFooterSecondState,
  handleSettingsSubpage,
  handleJackpotPopup,
  // handleAutoInputsSocket,
) {
  setctx(ctx => {
    return {
      ...ctx,
      funcs: {
        handleStake,
        handleShowAuto,
        handleSettings,
        handleAutoInputs,
        setFooterFirstState,
        setFooterSecondState,
        handleSettingsSubpage,
        handleJackpotPopup,
        // handleAutoInputsSocket,
      },
    }
  })
}

export const setGameAudioHelper = (audioInfo, setContext) => {
  setContext(ctx => {
    return { ...ctx, audio: { ...ctx.audio, ...audioInfo } }
  })
}

export function handleFuncsInAppContext(
  setContext,
  setMusic,
  setSound,
  setisMusicOff,
  setisSoundOff,
  setAudio,
  clearBetResponse,
  resetRoundUserUpdate
) {
  setContext(ctx => {
    return {
      ...ctx,
      appFuncs: {
        setMusic,
        setSound,
        setisMusicOff,
        setisSoundOff,
        setAudio,
        clearBetResponse,
        resetRoundUserUpdate
      },
    }
  })
}
